import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { SearchApiServiceChannel } from '@/app/(main)/(pages)/_types/search-api-response.type';
import { AnalyticsEnum, AnalyticsEnumKeyType } from '@/types/enums/analytics/analytics.enum';
import { ScheduleTabOrigin } from '@/types/enums/analytics/search/search-analytics.enum';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';

export interface ScheduleTabAnalytics {
  origin: ScheduleTabOrigin;
  modalidade?: string;
  entity?: string;
  entityType?: EntityTypeEnum;
}

export const CHANNEL_MODALITY: Record<SearchApiServiceChannel, string> = {
  [SearchApiServiceChannel.IN_PERSON]: 'presencial',
  [SearchApiServiceChannel.TELEHEALTH]: 'teleconsulta',
};

const SEE_OTHER_SCHEDULES_EVENT_BY_ORIGIN: Record<ScheduleTabOrigin, AnalyticsEnumKeyType> = {
  [ScheduleTabOrigin.SEARCH_RESULTS]: AnalyticsEnum.CLICK_SEE_OTHER_SCHEDULES,
  [ScheduleTabOrigin.PARTNER_PROFILE]: AnalyticsEnum.CLICK_PARTNER_OTHER_SCHEDULES,
  [ScheduleTabOrigin.PROFESSIONAL_PROFILE]: AnalyticsEnum.PROFESSIONAL_PROFILE_CLICK_OTHER_SCHEDULES,
};

export function trackSeeOtherSchedules(tabAnalytics: ScheduleTabAnalytics, schedule: SearchPartnerData): void {
  const event = SEE_OTHER_SCHEDULES_EVENT_BY_ORIGIN[tabAnalytics.origin];

  const isPartnerProfile = tabAnalytics.origin === ScheduleTabOrigin.PARTNER_PROFILE;

  getAnalyticsPlugin().track(event, {
    entity: tabAnalytics.entity,
    entityType: tabAnalytics.entityType,
    modalidade: tabAnalytics.modalidade,
    ...(isPartnerProfile ? { professional_id: schedule.professional?.id } : {}),
  });
}
